import './TwoColTextCard.scss';
import React from 'react';
import { cn as classNames } from 'ui/utils/bem';
import { Typography } from '@dataartdev/uikit/Typography';
import { Article } from '../Article/Article';
import { Slider } from '../ContentBuilder/templates/models/CTI_41.props';
import { NoteText } from '../NoteText/NoteText';

const cnTwoColTextCard = classNames('TwoColTextCard');

export const TwoColTextCard: React.FC<Slider> = ({ title, text, list }) => {
  return (
    <div className={cnTwoColTextCard()}>
      {title && <Typography.Title size="md">{title}</Typography.Title>}
      <div className={cnTwoColTextCard('Columns')}>
        {text && (
          <div className={cnTwoColTextCard('Description')}>
            <Article content={text} />
          </div>
        )}
        {list?.length > 0 && (
          <div className={cnTwoColTextCard('Info')}>
            <NoteText strings={list} />
          </div>
        )}
      </div>
    </div>
  );
};
